// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"3790b6a1","184":"7ecf17e0","685":"21c894a9","766":"322f6c8b","768":"fd7969a5","784":"bde958f0","971":"4cd27938"}[chunkId] + ".chunk.js";
};